import { getFormData } from './../formManagement';
import Steppp from 'lib/steppp/src/index';

const setupClickListener = (btnElems, clickHandler) => {
  btnElems.forEach((btnElem) => {
    btnElem.onclick = clickHandler;
  });
};

class MultistepForm {
  constructor(formElem) {
    this.formElem = formElem;
    const { moveTo } = Steppp(formElem);
    this.goToStep = moveTo;
    this.stepHistory = [];

    formElem.addEventListener(
      'focus',
      () => {
        this.trackStepView();
        this.updateProgressBar();
      },
      { capture: true, once: true }
    );

    formElem.addEventListener('steppp:complete', () => {
      this.updateProgressBar();
    });

    setupClickListener(formElem.querySelectorAll('[data-step-next]'), () =>
      this.handleNextClick()
    );
    setupClickListener(formElem.querySelectorAll('[data-step-back]'), () =>
      this.handleBackClick()
    );
  }

  getCurrentStep() {
    const steps = this.formElem.querySelectorAll('.FormBuilder-step');
    return Array.from(steps).find((step) =>
      step.hasAttribute('data-steppp-active')
    );
  }

  updateProgressBar() {
    const progressBar = this.formElem.querySelector('.FormBuilder-progressBar');
    if (!progressBar) {
      return;
    }

    const percentage = this.getCurrentStep().dataset.stepProgressPercentage;
    if (!percentage) {
      return;
    }

    progressBar.firstElementChild.style.width = `${percentage}%`;
    progressBar.ariaValueNow = percentage;
  }

  getNextStepConditions() {
    const logic = JSON.parse(this.getCurrentStep().dataset.stepLogic);
    return logic.conditions;
  }

  determineNextStep() {
    const conditions = this.getNextStepConditions();
    const formFields = getFormData(this.formElem);
    let nextStep = this.getCurrentStep().dataset.stepDefaultNext;

    for (let index = 0; index < conditions.length; index++) {
      const condition = conditions[index];
      if (formFields.hasOwnProperty(condition.fieldName)) {
        const value = formFields[condition.fieldName];
        if (value === condition.fieldValue) {
          nextStep = condition.nextStep;
          break;
        }
      }
    }

    return nextStep;
  }

  currentStepIsValid() {
    const formFields = getFormData(this.formElem);
    const currentStep = this.getCurrentStep();
    let stepIsValid = true;

    // eslint-disable-next-line guard-for-in
    for (const fieldName in formFields) {
      let fieldElem = currentStep.querySelector(`[name=${fieldName}]`);
      if (fieldElem) {
        let fieldIsValid = fieldElem.checkValidity();
        if (!fieldIsValid) {
          stepIsValid = false;
        }
      }
    }

    return stepIsValid;
  }

  handleNextClick() {
    if (!this.currentStepIsValid()) {
      return;
    }

    const currentStepName = this.getCurrentStep().dataset.stepppName;
    const nextStepName = this.determineNextStep();

    this.stepHistory.push(currentStepName);
    this.goToStep(nextStepName);
    this.trackStepView(nextStepName);
  }

  handleBackClick() {
    const stepName = this.stepHistory.pop();
    this.goToStep(stepName);
    this.trackStepView(stepName);
  }

  trackStepView(stepName = this.getCurrentStep().dataset.stepppName) {
    this.formElem.FormTracking.trackStepView({ stepName });
  }
}

export default MultistepForm;
